import { apiJson } from './http'

export function getModels() {
  return apiJson('/api/v1/ai/models')
}
